/**
 * Public filter hook for customer-facing pages
 * Wraps useAdminFilters with defaults appropriate for public product browsing
 */

import { useAdminFilters } from '../components/admin/shared/hooks/useAdminFilters';
import { PublicProductFilters } from '../utils/productFiltering';

/**
 * Hook for managing filter state on public product pages
 * Provides URL synchronization, debouncing, and automatic page reset
 */
export function usePublicProductFilters() {
  return useAdminFilters<PublicProductFilters>({
    page: 1,
    limit: 25,
    search: '',
    category: '',
    tier: '',
    priceMin: undefined,
    priceMax: undefined,
    sortBy: 'publishedAt',
    sortOrder: 'desc',
  });
}
